import debug from "debug";

function customDebug(namespace: string): debug.Debugger {
    const log = debug(namespace);
    log.log = console.log.bind(console);
    return log;
}

export default customDebug;